import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../service/loader.service';
import { ChartService } from '../../service/chart.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { ReportAnalyticsService } from '../../service/report-analytics.service';
import { ChartType, ChartDataSets, ChartOptions,ChartData } from 'chart.js';
@Component({
  selector: 'app-new-customer-registration',
  templateUrl: './new-customer-registration.component.html',
  styleUrls: ['./new-customer-registration.component.scss']
})
export class NewCustomerRegistrationComponent extends BaseComponent implements OnInit {

  chartData: number[]=[];
  public barChartLabels:string[] =[]
  public barChartData:any[] =[];
  public barChartType:string = 'bar';
  public barChartLegend:boolean = false;
  public barChartColors:Array<any> = [];
  //   public barChartOptions:any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true
  // };
  
  
  public barChartOptions = {
    scales: {
      xAxes: [{ 
        categoryPercentage: 0.7,   // default ~0.8; lower makes bars wider
        barPercentage: 0.9,
        ticks: { beginAtZero: true }
      }]
      // ,
      // yAxes: [{ ticks: { beginAtZero: true } }]
    },
    elements: {
      rectangle: {
        minBarLength: 8,
        borderWidth: 1
      }
    },
    // ... tooltips/hover from above
  };

  items = [];
  colorCount:number;
  constructor( 
         private loaderService: LoaderService
        ,private chartService:ChartService
        ,private reportAnalyticsService:ReportAnalyticsService
      ){ 
        
        super();
  }

  ngOnInit(): void {
  }

  CreateChartSelectedDateWise()  {
    //console.log("CreateChartSelectedDateWise");
    //alert("CreateChartSelectedDateWise");
      this.barChartData =[];
      this.chartData=[];
      this.barChartLabels=[];
      this.barChartData=[];
      if(this.items.length>0)
    {
      this.reportAnalyticsService.GetReport(this.items[0]["reportFromDate"],this.items[0]["reportToDate"],this.items[0]["period"],this.items[0]["year"],this.items[0]["month"],"NewRegisteredCustomerReport").subscribe(
      ress => {
        this.loaderService.hide();
         //console.log("ress",ress);
         if (ress.successed) {
          var data = ress.data;
      
      //#region Barchart
      const rows = data.customerReport || [];

      const monthNameToNum: Record<string, number> = {
        January: 1, February: 2, March: 3, April: 4, May: 5, June: 6,
        July: 7, August: 8, September: 9, October: 10, November: 11, December: 12
      };

      // If there is no sub-column (single series), draw a simple one-series bar chart
      if (!rows[0]?.subColumnName) {
        this.barChartLegend = false;
        // leave your color logic as-is if you prefer
        this.barChartColors = [{ backgroundColor: this.chartService.getColors(1) }];

        this.barChartLabels = [];
        this.chartData = [];
        for (let i = 0; i < rows.length; i++) {
          this.barChartLabels.push(rows[i].columnName);
          this.chartData.push(rows[i].columnValue);
        }
        this.barChartData = [{ data: this.chartData, label: (new Date()).getFullYear() }];
      } else {
        // ---- MULTI-SERIES (e.g., Year-wise datasets over Months) ----
        this.barChartLegend = true;

        // 1) Distinct years (columnName)
        const years: string[] = Array.from(new Set(rows.map((r: any) => r.columnName)));

        // 2) Distinct months (subColumnName) sorted by MonthNumber / monthNumber
        type MonthRec = { name: string; num: number };

      const monthRecords: MonthRec[] = rows.map((r) => ({
        name: r.subColumnName,
        num: (r.monthNumber ?? r.MonthNumber ?? monthNameToNum[r.subColumnName] ?? 99) * 1
      }));

      // De-dupe by name, keeping the smallest num for that name (in case of inconsistent data)
      const byName = new Map<string, MonthRec>();
      for (const m of monthRecords) {
        const prev = byName.get(m.name);
        if (!prev || m.num < prev.num) {
          byName.set(m.name, m);
        }
      }

      const monthsUniqueSorted = Array.from(byName.values()).sort((a, b) => a.num - b.num);
      this.barChartLabels = monthsUniqueSorted.map(m => m.name);

        // 3) Fast lookup by "year__month" -> value
        const valueByYearMonth = new Map<string, number>();
        for (const r of rows) {
          const key = `${r.columnName}__${r.subColumnName}`;
          valueByYearMonth.set(key, r.columnValue);
        }

        // 4) Build datasets aligned to labels, fill missing months with 0
        this.barChartData = years.map(y => {
          const series = this.barChartLabels.map(m => valueByYearMonth.get(`${y}__${m}`) ?? 0);
          return { data: series, label: y };
        });

        // (Optional) Colors: you can let Chart.js default, or compute one per dataset
        // this.barChartColors = years.map(() => ({}));
      }
      //#endregion

            //#region  Barchart old
            // if(data.customerReport[0].subColumnName === "undefined" ||data.customerReport[0].subColumnName === undefined|| data.customerReport[0].subColumnName === null){
            // console.log("if");
            //   this.barChartLegend=false;
            //   this.barChartColors=[{backgroundColor:(this.chartService.getColors(1))}] ;
            //   for (let i = 0; i < data.customerReport.length; i++) {

            //       this.barChartLabels.push(data.customerReport[i].columnName)
            //       this.chartData.push(data.customerReport[i].columnValue)
            //   }

            //   this.barChartData=[{data:this.chartData,label:(new Date()).getFullYear()}];
            // }
            // else
            // {
            //   this.barChartData=[];
            //   console.log("Else");
            //    this.barChartLegend=true;
            //   const distinctColumn = data.customerReport.filter(
            //     (customerReport, i, arr) => arr.findIndex(t => t.columnName === customerReport.columnName) === i
            //   );
            //  //console.log("distinctColumn");
            //  //console.log(distinctColumn);
            //   for (let dc = 0; dc < distinctColumn.length; dc++) {
            //       this.barChartColors=[];
            //       this.barChartLabels=[];
            //       this.chartData=[];

                  
            //       this.colorCount=0;
            //     for (let i = 0; i < data.customerReport.length; i++) {

            //      if(distinctColumn[dc].columnName === data.customerReport[i].columnName)
            //      {
            //       this.barChartLabels.push(data.customerReport[i].subColumnName)
            //       this.chartData.push(data.customerReport[i].columnValue)
            //       this.colorCount++;
            //      }
                 
            //     }
            //     this.barChartData.push({data:this.chartData,label:distinctColumn[dc].columnName});
            //   }
            // }
            //#endregion

         } else {
          this.toastrAlertService.errorToastr(ress.errorMessage);
        }
      },
      error => {
        this.loaderService.hide();
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('generalError'));
        }
      }
    )
     this.barChartData =[];
    this.chartData=[];
    this.barChartLabels=[];
    this.barChartData=[];
    this.items=[];
    this.loaderService.hide();
  }
}
  addItem(newItem: string) { 
  this.items.push(newItem);   
    this.CreateChartSelectedDateWise()
  }
   public chartClicked(e:any):void {
      //console.log(e);
    }

  public chartHovered(e:any):void {
      console.log(e);
    }
}
